(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('leafletMap', LeafletMap);

  LeafletMap.$inject = [
    'LeafletService',
    '$timeout'
  ];

  function LeafletMap(LeafletService, $timeout) {
    return {
      restrict: 'E',
      scope: {
        bounds: '<'
      },
      link: function link(scope, element, attrs) {
        $timeout(CreateMap);

        function CreateMap() {
          LeafletService.createMap(attrs.id, {
            // minZoom: 12,
            // maxZoom: 16,
            // TODO: add padding to bounds and set maxBounds
            // maxBounds: scope.bounds,
            inertia: true
          }).then(function(map) {
            map.fitBounds(scope.bounds);
            scope.$emit('leafletMapComplete', map);
          });
        }
      }
    };
  }
}());
